import React from "react";
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import TextField from "@mui/material/TextField";

// @ts-ignore
export const DateInput: React.FC<Omit<DatePickerProps<any, any>, "renderInput">> = (props) => (
  // @ts-ignore
  <DatePicker
    {...props}
    inputFormat="MM/DD/YYYY"
    renderInput={(params: any) => <TextField {...params} />}
  />
);
